import { ref } from 'vue'

// Pega o lang  da URL
const context = window.context

const relation = {
  PT: 'pt-BR',
  ES: 'es',
  EN: 'en-US',
}

export const langRelation =
  relation[context.user.linguagem] || 'pt-BR'

export const lang = ref(langRelation)
